import Vue from 'vue'
import App from './App.vue'
import router from './router';
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import 'bootstrap'; 
import 'bootstrap-icons/font/bootstrap-icons.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@fortawesome/fontawesome-free/js/all.js';
import './assets/css/style.css';

Vue.config.productionTip = false
Vue.use(Datetime);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
